import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-gradient-to-br from-primary-500 to-primary-700 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl">A</span>
              </div>
              <div className="flex flex-col">
                <span className="font-display font-bold text-lg leading-tight">Alpine Precision</span>
                <span className="text-xs text-primary-300">European Craftsmanship</span>
              </div>
            </div>
            <p className="text-sm text-slate-300 leading-relaxed">
              Combining European heritage with AI-powered precision to deliver world-class molding solutions at competitive prices.
            </p>
            <div className="flex space-x-3">
              <a
                href="https://www.facebook.com/alpineprecisionmold"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 bg-slate-700 hover:bg-primary-600 rounded-lg flex items-center justify-center transition-colors cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="https://www.linkedin.com/company/alpineprecisionmold"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 bg-slate-700 hover:bg-primary-600 rounded-lg flex items-center justify-center transition-colors cursor-pointer"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a
                href="https://www.instagram.com/alpineprecisionmold"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 bg-slate-700 hover:bg-primary-600 rounded-lg flex items-center justify-center transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-display font-semibold text-base mb-4">Services</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/injection-molding" className="text-sm text-slate-300 hover:text-primary-400 transition-colors cursor-pointer">
                  Injection Molding
                </Link>
              </li>
              <li>
                <Link to="/blow-molding" className="text-sm text-slate-300 hover:text-primary-400 transition-colors cursor-pointer">
                  Blow Molding
                </Link>
              </li>
              <li>
                <Link to="/3d-printing" className="text-sm text-slate-300 hover:text-primary-400 transition-colors cursor-pointer">
                  3D Printing
                </Link>
              </li>
              <li>
                <Link to="/toolmaking" className="text-sm text-slate-300 hover:text-primary-400 transition-colors cursor-pointer">
                  Advanced Toolmaking
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-display font-semibold text-base mb-4">Company</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-slate-300 hover:text-primary-400 transition-colors cursor-pointer">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/projects" className="text-sm text-slate-300 hover:text-primary-400 transition-colors cursor-pointer">
                  Past Projects
                </Link>
              </li>
              <li>
                <Link to="/resources" className="text-sm text-slate-300 hover:text-primary-400 transition-colors cursor-pointer">
                  Resources
                </Link>
              </li>
              <li>
                <Link to="/news" className="text-sm text-slate-300 hover:text-primary-400 transition-colors cursor-pointer">
                  News
                </Link>
              </li>
              <li>
                <Link to="/careers" className="text-sm text-slate-300 hover:text-primary-400 transition-colors cursor-pointer">
                  Careers
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-slate-300 hover:text-primary-400 transition-colors cursor-pointer">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/instant-quote" className="text-sm text-slate-300 hover:text-primary-400 transition-colors cursor-pointer">
                  Get Instant Quote
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-display font-semibold text-base mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-primary-400 mt-1"></i>
                <div className="text-sm text-slate-300">
                  <div className="font-medium">Southern California</div>
                  <div className="text-xs">United States</div>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-primary-400 mt-1"></i>
                <div className="text-sm text-slate-300">
                  <div className="font-medium">Netherlands</div>
                  <div className="text-xs">Europe</div>
                </div>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-mail-line text-primary-400"></i>
                <a href="mailto:info@alpineprecisionmold.com" className="text-sm text-slate-300 hover:text-primary-400 transition-colors cursor-pointer">
                  info@alpineprecisionmold.com
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-phone-line text-primary-400"></i>
                <a href="tel:+19493334444" className="text-sm text-slate-300 hover:text-primary-400 transition-colors cursor-pointer">
                  +1 (949) 333-4444
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <p className="text-sm text-slate-400">
              © 2025 Alpine Precision Mold. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <Link to="/privacy" className="text-sm text-slate-400 hover:text-primary-400 transition-colors cursor-pointer">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-sm text-slate-400 hover:text-primary-400 transition-colors cursor-pointer">
                Terms of Service
              </Link>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-sm text-slate-400 hover:text-primary-400 transition-colors cursor-pointer">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
